import { Component, OnInit, HostListener, Host, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators, FormControlName } from '@angular/forms';
import { AppUtilityService } from '../common/app-utility.service'
import { TransactionConstants } from '../app.constants';
import { AppComponent } from '../app.component';
import { CurrencyPipe } from '@angular/common';
import { EnglishTranslation, MalayTranslation } from '../app.constants';

declare var $: any;

@Component({
  selector: 'app-about-your-business-info',
  templateUrl: './about-your-business-info.component.html',
  styleUrls: ['./about-your-business-info.component.scss']
})
export class AboutYourBusinessInfoComponent implements OnInit {

  AboutYourBusinessInfo: FormGroup;
  isEditMode: boolean = false;
  IDNumber: any;
  UltimateOwners: any[];
  ownerDisplay: boolean =false;
  companyOwnerTemplate: string
  textContent: any;
  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private AppUtility: AppUtilityService,
    public appComp: AppComponent,
    private currencyPipe: CurrencyPipe,
  ) {

  }


  ResponseBody: any;
  RefCCDL: any;

  @HostListener('document:keypress', ['$event'])
  @HostListener('click', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === "annual_biz_turnover") {
      return this.AppUtility.numericOnlyValidation(elemValue.key)
    }
    if (elemValue.target.id === "companyOwnerYes") {
        this.companyOwnerClick()
    }
    
  }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.AboutYourBusinessInfoScreen : MalayTranslation.AboutYourBusinessInfoScreen;

    this.AboutYourBusinessInfo = this.formBuilder.group(
      {
        business_operates_in: ['', Validators.required],     
        salesOrigin: ['', Validators.required],        
        incomeFromBusinessRevenue: [false],
        proceedsFromInvestment: [false],
        incomeFromEmployment: [false],
        incomeFromOtherSources: [false],
        incomeFromOtherSourceValue: [''],
        companyOwner: ['',Validators.required],
        annualBizTurnover: ['',Validators.required]
          
      }
    );

    
 this.AboutYourBusinessInfo.valueChanges.subscribe(form =>{
    if(form.annualBizTurnover) {
        this.AboutYourBusinessInfo.patchValue({
            annualBizTurnover: this.currencyPipe.transform(form.annualBizTurnover.replace(/\D/g, '').replace(/^0+/,''),' ','symbol','1.0-0')
        },{emitEvent:false});
    }
});

    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    function disableSelect(elmntId) {
      $(".select-cont#" + elmntId).append("<div class='disabled-select'></div>");
    }

    function enableSelect(elemntId) {
      $("#" + elemntId + " div.disabled-select").remove();
    }
    this.callDropdownValues();
    this.callReadRequest();
    this.hideOnPageLoad();


  $(document).ready(() => {
    var initialFundingChecked = false; 
        

    $("#initial-funding").click(function () {
      if ($(this).is(":checked")) {
        $(".others-funding").show();
        initialFundingChecked = true;
      } else {
        $(".others-funding").hide();
        initialFundingChecked = false;

      }
    })
      

    $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
            return false;
        }
    });
      
    $("#obaoform").validate({
          rules: {
              account_mainly_used: {
                  required: true
              },
              others_account: {
                  required: false
              },
              major_sales_originate: {
                  required: true
              },
              others_initial_funding: {
                  required: false                 
              },
              
              "fund_list[]": {
                  required: true,
                  minlength: 1
              },
              "owner_list[]": {
                  required: true
              },
              
              check_crimea: {
                  required: {
                      depends: function () {
                          if (this.check_crimea) {
                              return true;
                          } else {
                              return false
                          }
                      }
                  },
                  maxlength: 1
              },
              generate_income: {
                  required: true
              },
              annual_biz_turnover: {
                  required: true
              }
          },
          // (Begin) CJT 08Jul2020 to display error message when user skipped the field
          onfocusout: function (element) {
              $(element).valid();
          },
          // (End) CJT 08Jul2020
          messages: {
             
              others_account: {
                  required: "Please fill in the text area"
              },
              major_sales_originate: {
                  required: "Please select an option"
              },
              others_initial_funding: {
                  required: "Please fill in the text area"
              },
              "fund_list[]": {
                  required: this.textContent.fundListError
              },
              "owner_list[]": {
                required: this.textContent.ownerListError
            },
              check_crimea: {
                  required: "Please select yes or no"
              },
              annual_biz_turnover : {
                  required: this.textContent.turnOverError
              }
          },
          errorPlacement: function (error, element) {

              if (element.attr("name") == "account_mainly_used") {
                  error.appendTo($("#account_mainly_used_error_container"));
              }
              if (element.attr("name") == "others_account") {
                  error.appendTo($("#account_mainly_used_error_container"));
              }

              if (element.attr("name") == "major_sales_originate") {
                  error.appendTo($("#major_sales_originate_error_container"));
              }
              
              if (element.attr("name") == "fund_list[]") {
                  error.appendTo($("#initial_fund_error_container"));
              }
              if (element.attr("name") == "others_initial_funding") {
                  error.appendTo($("#initial_fund_error_container"));
              }
              if (element.attr("name") == "owner_list[]") {
                error.appendTo($("#initial_owner_error_container"));
              }
              if (element.attr("name") == "check_crimea") {
                  error.appendTo($("#check_crimea_error_cont"));
              }

              if(element.attr("name") == "annual_biz_turnover"){
                  error.appendTo($("#annual_biz_turnover_error_container"))
              }
            

          },
          submitHandler: function (form) {
              // $("#btn-next").prop("disabled", true);
          }         

      });
  });
  }
  

  onSubmit() {    
    if ($("#obaoform").valid()) {
      let serviceBody = {
            "UltimateOwners": [
                {
                    "StrSelected": this.AboutYourBusinessInfo.value.companyOwner,
                    "IDNumber": this.IDNumber
                }
            ],
            "KYCQuestionnaires": {
              "MainOperatingCountry": this.AboutYourBusinessInfo.value.business_operates_in,
              "AnnualBizTurnover": this.AboutYourBusinessInfo.value.annualBizTurnover,
              "SourceOfFund": [
                  {
                      "IsSelected": this.AboutYourBusinessInfo.value.incomeFromBusinessRevenue,
                      "Name": "BI",
                      "Value": "Business Revenue"
                  },
                  {
                      "IsSelected": this.AboutYourBusinessInfo.value.incomeFromEmployment,
                      "Name": "IE",
                      "Value": "Income from employment"
                  },
                  {
                      "IsSelected": this.AboutYourBusinessInfo.value.proceedsFromInvestment,
                      "Name": "PI",
                      "Value": "Proceeds from investments"
                  },
                  {
                      "IsSelected": this.AboutYourBusinessInfo.value.incomeFromOtherSources,
                      "Name": "OTH",
                      "Value": "Others",
                      "Other": this.AboutYourBusinessInfo.value.incomeFromOtherSourceValue
                  }
              ],
              "SalesOrigin": {
                  "Country": this.AboutYourBusinessInfo.value.salesOrigin
              }
          }
      };
      this.callSaveRequest();
    }
  }
 

  async restConnect(data, reqID: String) {
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    return ServResponse;
  }

  async callDropdownValues() {
    this.RefCCDL = JSON.parse(sessionStorage.RefCCDL);
  }
  
  async callReadRequest() {
    var data = {};
    $('#companyOwnerHidden').val(null)
    var ServResponse = await this.restConnect(data, "R0040");
    if (ServResponse.Status == "Success") {
      this.ResponseBody = ServResponse;
      this.setDataResponse(this.ResponseBody);
    //   if (this.ResponseBody.UltimateOwners.length == 1) {
    //         this.setDataResponse(this.ResponseBody);
    //         this.ownerDisplay = true
    //     } else {
    //         this.setDataResponse(this.ResponseBody);
    //         this.ownerDisplay = false
    //     }
    } else {
    }

    this.UltimateOwners = this.ResponseBody.UltimateOwners
    // console.log(this.UltimateOwners)

  }

  companyOwnerClick(){
    this.AboutYourBusinessInfo.controls.companyOwner.setValue(null)
    if(this.UltimateOwners){
        for(var i =0; i < this.UltimateOwners.length; i++){
            if($('input[id="companyOwnerYes"].check_'+this.UltimateOwners[i].IDNumber+':checked').val()=='true'){
                this.AboutYourBusinessInfo.controls.companyOwner.setValue('true')
            }
        }
    }
    this.AboutYourBusinessInfo.controls.companyOwner.updateValueAndValidity()
  }

  async callSaveRequest() {
    
    if(this.UltimateOwners.length>1){
        for(var i =0; i < this.UltimateOwners.length; i++){
            if($('input[id="companyOwnerYes"].check_'+this.UltimateOwners[i].IDNumber+':checked').val()=='true'){
                this.UltimateOwners[i].StrSelected='true'
                $('#companyOwnerHidden').val('true')
            }else{
                this.UltimateOwners[i].StrSelected=null
            }
        }
    }else{
        this.UltimateOwners[0].StrSelected=$('input[name="companyOwner"]:checked').val()
    }
    
    var data = {
      KYCQuestionnaires: {
        MainOperatingCountry: this.AboutYourBusinessInfo.value.business_operates_in,   
        "AnnualBizTurnover": this.AboutYourBusinessInfo.value.annualBizTurnover,    
        "SalesOrigin": {
          "Country": this.AboutYourBusinessInfo.value.salesOrigin
        },
        "SourceOfFund": [
          {
              "IsSelected": this.AboutYourBusinessInfo.value.incomeFromBusinessRevenue,
              "Name": "BI",
              "Value": "Business Revenue"
          },
          {
              "IsSelected": this.AboutYourBusinessInfo.value.incomeFromEmployment,
              "Name": "IE",
              "Value": "Income from employment"
          },
          {
              "IsSelected": this.AboutYourBusinessInfo.value.proceedsFromInvestment,
              "Name": "PI",
              "Value": "Proceeds from investments"
          },
          {
              "IsSelected": this.AboutYourBusinessInfo.value.incomeFromOtherSources,
              "Name": "OTH",
              "Value": "Others",
              "Other": this.AboutYourBusinessInfo.value.incomeFromOtherSourceValue
          }
        ],       
      },      
      "UltimateOwners": this.UltimateOwners
    }
    var ServResponse = await this.restConnect(data, "S0040");
    if (ServResponse.Status == "Success") {
      if (!this.isEditMode) {
        this.router.navigate(['/tax-status']);
      } else {
        this.router.navigate(['/director-confirm']);
      }
    }
    else {

    }
   
  }

  setDataResponse(data) {
    var defaultCountry: String = data.KYCQuestionnaires.MainOperatingCountry;
    if (defaultCountry == "") {
      defaultCountry = "MY";
    }
   
    if (data.KYCQuestionnaires.SalesOrigin && data.KYCQuestionnaires.SalesOrigin.Country != "") {
      this.AboutYourBusinessInfo.controls.salesOrigin.setValue(data.KYCQuestionnaires.SalesOrigin.Country);
    } else {
        this.AboutYourBusinessInfo.controls.salesOrigin.setValue("MY");
    }

    if (data.KYCQuestionnaires && data.KYCQuestionnaires.MainOperatingCountry != "") {
      this.AboutYourBusinessInfo.controls.business_operates_in.setValue(data.KYCQuestionnaires.MainOperatingCountry);
    } else {
        this.AboutYourBusinessInfo.controls.business_operates_in.setValue("MY");
    }

    if(data.KYCQuestionnaires && data.KYCQuestionnaires.AnnualBizTurnover != ""){
        this.AboutYourBusinessInfo.controls.annualBizTurnover.setValue(data.KYCQuestionnaires.AnnualBizTurnover);
    }else{
        this.AboutYourBusinessInfo.controls.annualBizTurnover.setValue("");
    }
    
    if (data.KYCQuestionnaires.SourceOfFund && data.KYCQuestionnaires.SourceOfFund.length > 0) {
      for (let source of data.KYCQuestionnaires.SourceOfFund) {
          if (source.Name === TransactionConstants.BusinessInvestment) {
              this.AboutYourBusinessInfo.controls.incomeFromBusinessRevenue.setValue(source.IsSelected);
          } else if (source.Name === TransactionConstants.IncomeFromEmployment) {
              this.AboutYourBusinessInfo.controls.incomeFromEmployment.setValue(source.IsSelected);
          } else if (source.Name === TransactionConstants.ProceedsFromBusiness) {
              this.AboutYourBusinessInfo.controls.proceedsFromInvestment.setValue(source.IsSelected);
          } else if (source.Name === TransactionConstants.IncomeFromOtherSources) {
              this.AboutYourBusinessInfo.controls.incomeFromOtherSources.setValue(source.IsSelected);
              if (source.IsSelected) {
                  $(".others-funding").show();
                  this.AboutYourBusinessInfo.controls.incomeFromOtherSourceValue.setValue(source.Other);
                  this.AboutYourBusinessInfo.get('incomeFromOtherSourceValue').setValidators([Validators.required]);
                  this.AboutYourBusinessInfo.get('incomeFromOtherSourceValue').updateValueAndValidity();
              }
          }
      }
    } 
    
    if(data.UltimateOwners.length == 1) {
        this.ownerDisplay = true;
        this.AboutYourBusinessInfo.controls.companyOwner.setValue(data.UltimateOwners[0].StrSelected)
    } else {
        this.ownerDisplay = false;
        var tempHTML = ''
        for (var i=0; i<data.UltimateOwners.length; i++){
            var name = data.UltimateOwners[i].Name;
            if(i==2 && sessionStorage.language == 'ms') {
                name = 'Individu lain';
            }
            tempHTML = tempHTML + '<label class="chk-cont"> '+ name +'<input type="checkbox" class="check_'+data.UltimateOwners[i].IDNumber+'" id="companyOwnerYes" name="owner_list[]" value="true" ><span class="checkmark '+ data.UltimateOwners[i].IDNumber +'"></span></label>'
        }
        this.companyOwnerTemplate = tempHTML
    }
  
    this.AboutYourBusinessInfo.updateValueAndValidity();
    $('#ultimateOwners').html(tempHTML)

    for (var i=0; i<data.UltimateOwners.length; i++){
        if(data.UltimateOwners[i].StrSelected == 'true'){
            $('.' + data.UltimateOwners[i].IDNumber).trigger('click')
            this.AboutYourBusinessInfo.controls.companyOwner.setValue('true')
        }
    }
  }



  public incomeFromOtherSources(event) {
    if (!event.target.checked) {
        this.AboutYourBusinessInfo.controls.incomeFromOtherSourceValue.setValue('');
        this.AboutYourBusinessInfo.get('incomeFromOtherSourceValue').clearValidators();
    } else {
        this.AboutYourBusinessInfo.get('incomeFromOtherSourceValue').setValidators([Validators.required]);
    }
    this.AboutYourBusinessInfo.get('incomeFromOtherSourceValue').updateValueAndValidity();
  }

  public hideOnPageLoad() {    
    $(".others-funding").hide();  
}

}
